import React, { useState, useEffect } from 'react';
import { StringUtils } from '../utils/strings';
import { getTempData, getResources } from '../stateManagement/actions/data';
import { useDispatch } from 'react-redux';
import { Table, Button, Modal } from 'antd';
import ManualMappingForm from '../components/forms/manualMappingForm';
import { ADMIN_ACCESS, PARTITION_MAIN, PARTITION_THD } from "../utils/constants";
import { useLocation } from "react-router-dom";

const MappingPage = () => {

  const dispatch = useDispatch();
  const location = useLocation();
  const PARTITION = location.pathname.includes(PARTITION_THD) ? PARTITION_THD : PARTITION_MAIN;
  const [tempData, setTempData] = useState([]);
  const [resources, setResources] = useState(null);
  const [reloader, setReloader] = useState(false);

  const forceRerender = () => setReloader(prevState => !prevState); 

  //Handling new publisher modal 
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  
  const showMappingModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
  };
  
  const handleMappingCancel = () => {
    setIsModalVisible(false);
    setSelectedId(null);
  };

  useEffect(() => {
    dispatch(getTempData({partition: PARTITION},setTempData));
    dispatch(getResources(setResources));
  }, [dispatch, reloader, PARTITION]);

  const tableColumns = [
    {
      title: '#',
      dataIndex: 'key',
      rowScope: 'row',
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'data',
      sorter: (a, b) => a.dimension - b.dimension,
    },
    {
      title: 'Platform',
      dataIndex: 'provider',
      key: 'provider',
      sorter: (a, b) => a.dimension - b.dimension,
    },
    {
      title: 'Publisher',
      dataIndex: 'publisher',
      key: 'publisher',
      sorter: (a, b) => a.dimension - b.dimension,
    },
    {
      title: 'Website',
      dataIndex: 'website',
      key: 'website',
      sorter: (a, b) => a.dimension - b.dimension,
    },
    {
      title: 'Impressions',
      dataIndex: 'impressions',
      key: 'impressions',
      sorter: (a, b) => a.impressions - b.impressions,
      render: (impressions) => StringUtils.beautifyLongNumbers(impressions, ' ')
    },
    {
      title: 'Net Revenue',
      dataIndex: 'publisherRevenue',
      key: 'publisherRevenue',
      sorter: (a, b) => a.publisherRevenue - b.publisherRevenue,
      render: (publisherRevenue) => StringUtils.beautifyLongNumbers(publisherRevenue, ' ')
    },
    {
      title: 'Action',
      key: 'action',
      render: (data) => (<Button onClick={() => showMappingModal(data._id)} type="link">Map</Button>)
    },
  ];


  return (<>
    <Modal 
      title="Manual mapping" 
      open={isModalVisible} 
      onCancel={handleMappingCancel}
      footer={null}
      width={"fit-content"}
    >
      <ManualMappingForm 
        websitesList={resources?.websites}
        publishersList={resources?.publishers.filter(i=>i.returnedValue !== ADMIN_ACCESS)}
        currentValues={tempData.find(i => i._id === selectedId)}
        closeModal={handleMappingCancel}
        partition={PARTITION}
      />
    </Modal>
    <h2>Unmapped data:</h2>
    <div className="table-container">
      <p>Data mapping process might take a while. Please, refresh the data after a few seconds to see the updates.</p>
      <Button danger onClick={forceRerender}>Refresh data</Button>
      <Table 
        className="summary-table" 
        columns={tableColumns} 
        dataSource={tempData.map((i, index)=>({...i, key: index + 1}))} 
        scroll={{x: '70vw'}}
      />
    </div>
  </>);
};
export default MappingPage;